var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from 'react';
import { analytics } from '../../communication';
import { t, tReact } from '@mp/locale';
import Button from '../../button';
import { clearOrderId, submitOrder, TRACKING_NAMESPACE, trackingEvents } from '../../services/schedulerService';
import './Review.scss';
import { AppPropsContext } from '../../hooks/AppPropsContext';
import { MessageContext } from '../../hooks/MessageContext';
import { OrderContext } from '../../hooks/OrderContext';
import { StepContext } from '../../hooks/StepContext';
import { SchedulerDataContext } from '../../hooks/SchedulerDataContext';
import StepButtons from '../StepButtons/StepButtons';
import { AppointmentReview, ContactReview, PropertyInfoReview, Surcharge, SummaryReview, TotalReview, } from '../../capture-service-review/mp-capture-service-review';
import useLoader from '../../hooks/useLoader';
function Update(_a) {
    var step = _a.step, section = _a.section;
    var goToStep = useContext(StepContext).goToStep;
    return (_jsx("div", __assign({ className: "item-actions" }, { children: _jsx(Button, { dark: true, htmlId: "mp-capture-service-go-to-address", label: t('COMMON.ACTIONS.update'), buttonType: "secondary", onClick: function () { return goToStep(step, section); } }) })));
}
export default function Review() {
    var _a = useContext(AppPropsContext), canCheckout = _a.canCheckout, onComplete = _a.onComplete, suppressTotal = _a.suppressTotal;
    var schedulerData = useContext(SchedulerDataContext).schedulerData;
    var order = useContext(OrderContext).order;
    var _b = useState(false), disableButtons = _b[0], setDisableButtons = _b[1];
    var setMessage = useContext(MessageContext).setMessage;
    var _c = useContext(StepContext), next = _c.next, goToStep = _c.goToStep;
    var lastStep = 'review';
    var _d = useLoader(), startLoader = _d.startLoader, stopLoader = _d.stopLoader;
    var isValid = function () {
        return !disableButtons;
    };
    var handleTracking = function (eventString, event) {
        var eventName = "".concat(eventString.toUpperCase(), "_CLICKED");
        analytics.track(TRACKING_NAMESPACE, trackingEvents[eventName], {});
    };
    var handleOrderSubmitSuccess = function () {
        var _a, _b;
        analytics.track(TRACKING_NAMESPACE, trackingEvents.SUBMITTED_CAPTURE_SERVICES_ORDER, {
            id: order.id,
        });
        // Summary Step Event
        analytics.track(TRACKING_NAMESPACE, trackingEvents.CAPTURE_SERVICES_ORDER_PROGRESS, {
            address_latitude: (_a = order === null || order === void 0 ? void 0 : order.address) === null || _a === void 0 ? void 0 : _a.address_latitude,
            address_longitude: (_b = order === null || order === void 0 ? void 0 : order.address) === null || _b === void 0 ? void 0 : _b.address_longitude,
            id: order.id,
            step: 'summary',
        });
        sessionStorage.removeItem('order-details');
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        setDisableButtons(true);
        startLoader();
        if (onComplete) {
            onComplete({
                id: order.id,
            })
                .then(function () {
                handleOrderSubmitSuccess();
                setDisableButtons(false);
                clearOrderId();
            })
                .catch(function (error) {
                var _a, _b;
                setDisableButtons(false);
                setMessage((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message);
            })
                .finally(function () {
                stopLoader();
            });
        }
        else {
            submitOrder()
                .then(function () {
                handleOrderSubmitSuccess();
                clearOrderId();
                setDisableButtons(false);
                next();
            })
                .catch(function (error) {
                var _a, _b;
                setDisableButtons(false);
                setMessage((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message);
            })
                .finally(function () {
                stopLoader();
            });
        }
    };
    return (_jsxs("div", __assign({ className: "mp-capturesvc-review" }, { children: [_jsx("h1", __assign({ className: "mp-capturesvc-step-title" }, { children: t('CAPTURE_SERVICES.ORDER.REVIEW.title') })), _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", __assign({ className: "mp-capturesvc-review-form" }, { children: [_jsxs("div", __assign({ className: "mp-capturesvc-review-info" }, { children: [_jsx(PropertyInfoReview, { order: order, update: {
                                            location: _jsx(Update, { step: 0, section: "coverage" }),
                                            captureDetails: _jsx(Update, { step: 0, section: "type" }),
                                            propertyDetails: _jsx(Update, { step: 0, section: "space" }),
                                        } }), _jsx(AppointmentReview, { order: order, update: _jsx(Update, { step: 1 }) }), _jsx(ContactReview, { order: order, update: _jsx(Update, { step: 2 }) }), _jsx(Surcharge, { order: order }), _jsx(SummaryReview, { order: order })] })), _jsx(TotalReview, { order: order, handleTracking: handleTracking, suppressTotal: suppressTotal }), (order === null || order === void 0 ? void 0 : order.pricing_type) !== 'Contract' && (_jsx("div", __assign({ className: "mp-capturesvc-review-terms-of-services", onClick: function (e) { return handleTracking('TERMS_OF_SERVICE', e); } }, { children: tReact('CAPTURE_SERVICES.ORDER.REVIEW.terms', null, {
                                    url: 'https://matterport.com/legal/msa',
                                }, true) })))] })), _jsx(StepButtons, { disableAll: disableButtons, valid: isValid, nextButtonLabel: canCheckout ? t('COMMON.ACTIONS.continueToCheckout') : t('COMMON.ACTIONS.agree') })] }))] })));
}
